import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { isEmailValid } from "../../../state/selectors";
import TEXT from "../../../text-consts";

interface StateProps {
    isEmailOk: boolean;
}

type PersonalDetailsContinueButtonProps = StateProps;

const PersonalDetailsContinueButton: React.FC<PersonalDetailsContinueButtonProps> = ({ isEmailOk }) => (
    <Button id="onboarding-email-form-button" form={FORM_ID.ONBOARDING_EMAIL} disabled={!isEmailOk} type="submit">
        {TEXT.ONBOARDING_B2B.CONTACT_INFORMATION.BUTTON}
    </Button>
);

const mapStateToProps = (state: RootState): StateProps => ({
    isEmailOk: isEmailValid(state),
});

export default connect(mapStateToProps)(PersonalDetailsContinueButton);
